import { render, staticRenderFns } from "./SurveyDetailsQuestions.vue?vue&type=template&id=21784657&"
import script from "./SurveyDetailsQuestions.vue?vue&type=script&lang=js&"
export * from "./SurveyDetailsQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports